import get from 'transmute/get';
export const getMessengerConnectionsAsyncData = get('messengerConnections');